import React from "react";
import { Link } from "react-router-dom";
import { BRAND, DIREKTORIBIZ_URL } from "@/lib/constants";

export const Footer = () => (
  <footer className="border-t border-[#0f3f2f]/10 bg-[#f4f7f5] mt-16" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 grid gap-8 sm:grid-cols-3">
      <div>
        <p className="font-heading font-extrabold text-[#0f3f2f] text-lg">{BRAND}</p>
        <p className="mt-2 t-body text-sm max-w-xs">
          Kad perniagaan bercetak untuk usahawan, freelancer dan perniagaan kecil di Malaysia.
        </p>
      </div>
      <div>
        <p className="t-label">Pautan</p>
        <ul className="mt-3 space-y-2 text-sm text-[#4a5a53]">
          <li><Link to="/" className="hover:text-[#0f3f2f]">Utama</Link></li>
          <li><Link to="/semak" className="hover:text-[#0f3f2f]">Semak Tempahan</Link></li>
          <li>
            <a
              href={DIREKTORIBIZ_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#0f3f2f]"
              data-testid="footer-direktoribiz-link"
            >
              DirektoriBiz.My
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p className="t-label">Penghantaran</p>
        <ul className="mt-3 space-y-2 text-sm text-[#4a5a53]">
          <li>Harga termasuk penghantaran ke Semenanjung Malaysia.</li>
          <li>Tambahan RM10 untuk Sabah, Sarawak &amp; W.P. Labuan.</li>
          <li>Tambahan RM30 untuk Singapura.</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#0f3f2f]/10 py-5 text-center text-xs text-[#6b7a73]">
      © {new Date().getFullYear()} {BRAND}. Hak cipta terpelihara.
    </div>
  </footer>
);
